module.exports = __webpack_public_path__ + "img/candlingInfertile.9b124a01.svg";